import { render, staticRenderFns } from "./DccSummary.vue?vue&type=template&id=56b60759&scoped=true"
import script from "./DccSummary.vue?vue&type=script&lang=js"
export * from "./DccSummary.vue?vue&type=script&lang=js"
import style0 from "./DccSummary.vue?vue&type=style&index=0&id=56b60759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b60759",
  null
  
)

export default component.exports